import React from 'react'
// @ts-ignore
export const AppContext = React.createContext()